import { render, staticRenderFns } from "./InstructionsView.vue?vue&type=template&id=9498aed4&"
import script from "./InstructionsView.vue?vue&type=script&lang=ts&"
export * from "./InstructionsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports